import { apiClient } from "./apiClient";
import { unwrapApiResponse } from "../shared/utils/apiResponse";

export type GstinCheckResult = {
  found: boolean;
  name?: string;
  legalName?: string;
  address?: string;
  status?: string;
  constitution?: string;
  source?: string;
};

export type GstinCaptchaResult = {
  sessionId: string;
  captchaImage: string;
};

export async function checkGstin(gstin: string) {
  const { data } = await apiClient.get("/gstin-lookup/check", { params: { gstin } });
  return unwrapApiResponse<GstinCheckResult>(data);
}

export async function getGstinCaptcha() {
  const { data } = await apiClient.get("/gstin-lookup/captcha");
  return unwrapApiResponse<GstinCaptchaResult>(data);
}

export async function lookupGstin(payload: { gstin: string; captcha: string; sessionId: string }) {
  const { data } = await apiClient.post("/gstin-lookup", payload);
  return unwrapApiResponse<Omit<GstinCheckResult, "found">>(data);
}
